/**
 * Base implementation of a Coral model class.
 */
export class CoralModel {
}
